// src/redux/slices/searchSlice.js
import { createSlice } from '@reduxjs/toolkit';

const searchSlice = createSlice({
  name: 'search',
  initialState: {
    searchActive: false,
  },
  reducers: {
    activateSearch: (state) => {
      state.searchActive = true;
    },
    deactivateSearch: (state) => {
      state.searchActive = false;
    },
  },
});

export const { activateSearch, deactivateSearch } = searchSlice.actions;
export default searchSlice.reducer;
